<template>
    <div>
        <group-element
                :selectable="movingElement"
                :movable="!isReadOnly && movingElement"
                :resizable="!isReadOnly && movingElement"
                :deletable="!isReadOnly && isEditElement"
                :id.sync="elementCoordinate.id"
                :x.sync="elementCoordinate.x"
                :y.sync="elementCoordinate.y"
                :width.sync="elementCoordinate.width"
                :height.sync="elementCoordinate.height"
                :customMoveActionExist="isCustomMoveExist"
                v-on:customMoveAction="delayedMove"
                v-on:moveShape="onMoveShape"
                v-on:removeShape="onRemoveShape"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:dblclick="openPanel"
                v-on:addToGroup="onAddToGroup"
                :label.sync="namePanel"
                :image.sync="setImg"
                :_style="{
                'vertical-align': 'top',
                'font-weight': 'bold',
                'font-size': '16'
                }"
        >
            <sub-elements v-if="isHexagonalModeling">
                <geometry-polygon
                        :vertices="[ [22,0], [78,0], [100,50], [78,100], [22,100], [0,50],[22,0] ]"
                        :_style="{
              'fill-r': 1,
              'fill-cx': .1,
              'fill-cy': .1,
              'stroke-width': 1.4,
              'stroke': '#000000',
              'fill': '#00ff0000',
              'fill-opacity': 1,
              'vertical-align': 'top',
              'font-weight': 'bold',
              'font-size': '16',
               'r': '1'}"
                ></geometry-polygon>
            </sub-elements>

            <sub-elements v-else>
                <geometry-rect
                        v-if="movingElement"
                        :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 1.4,
          'stroke': '#000000',
          'fill-opacity': 1,
          'vertical-align': 'top',
          'font-weight': 'bold',
          'font-size': '16',
          'r': '1'
        }">
                </geometry-rect>

                <geometry-rect
                        v-else
                        :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 1.4,
          'stroke': '#000000',
          'fill': '#e3e1e1',
          'fill-opacity': .5,
          'vertical-align': 'top',
          'font-weight': 'bold',
          'font-size': '16',
          'r': '1'
        }">
                </geometry-rect>

            </sub-elements>

            <storming-sub-controller :type="value._type" :value="value"
                                     :readOnly="isReadOnly && !isMembers"></storming-sub-controller>
            <sub-controller
                    :image="'class.png'"
                    @click.prevent.stop="openClassDiagram"
            ></sub-controller>

            <sub-elements v-if="!isHexagonalModeling"  v-for="(index) in newEditUserImg.length">
                <image-element
                        v-bind:image="newEditUserImg[index-1].picture"
                        :sub-width="'24px'"
                        :sub-height="'24px'"
                        :sub-right="(10*(index-1))+'px'"
                        :sub-bottom="value.elementView.height"
                >
                </image-element>
            </sub-elements>

        </group-element>


        <bounded-context-panel
                v-if="propertyPanel"
                v-model="value"
                :readOnly="!isEditElement"
                :newEditUserImg="newEditUserImg"
                :image="image"
                :validationLists="filteredElementValidationResults"
                @close="closePanel"
                @changedPanelValue="changedPanelValue"
        ></bounded-context-panel>

    </div>
</template>

<script>
    import BoundedContextPanel from "../panels/BoundedContextPanel";
    import Element from './EventStormingModelElement'
    import GroupElement from "../../../opengraph/shape/GroupElement";
    import ImageElement from "../../../opengraph/shape/ImageElement";
    import SubElements from "../../../opengraph/shape/SubElements";

    var changeCase = require('change-case');
    var pluralize = require('pluralize');
    var path = require('path');
    var yamlpaser = require('js-yaml');
    var _ = require('lodash')

    export default {
        components: {SubElements, ImageElement, GroupElement,BoundedContextPanel},
        mixins: [Element],
        name: 'bounded-context-definition',
        props: {},
        computed: {
            // showError() {
            //     var me = this
            //     if (me.value.name == '') {
            //         return 'Please give a name.'
            //     }
            //
            //     return null
            // },
            defaultStyle() {
                return {}
            },
            className() {
                return 'org.uengine.modeling.model.BoundedContext'
            },
            createNew(elementId, x, y, width, height, description, label) {
                return {
                    _type: 'org.uengine.modeling.model.BoundedContext',
                    name: 'BoundedContext' + x,
                    oldName: '',
                    // namePlural: '',
                    // namePascalCase: '',
                    description: null,
                    author: null,
                    aggregates: [],
                    policies: [],
                    members: [],
                    viewes: [],
                    gitURL: null,
                    elementView: {
                        '_type': 'org.uengine.modeling.model.BoundedContext',
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': 350,
                        'height': 350,
                        'style': JSON.stringify({})
                    },
                    hexagonalView:{
                        '_type': 'org.uengine.modeling.model.BoundedContextHexagonal',
                        'id': elementId,
                        'x': 0,
                        'y': 0,
                        'width': 0,
                        'height': 0,
                        'style': JSON.stringify({})
                    },
                    portGenerated: 0,
                    // groups: [],
                    tempId: '',
                    templatePerElements: {},
                    preferredPlatform: 'spring-boot',
                    // innerElement: []
                }
            }
        },
        data: function () {
            return {
                itemH: 20,
                titleH: (this.value.classReference ? 60 : 30),
                reference: this.value.classReference != null,
                referenceClassName: this.value.classReference,

                // UML Class Diagram
                aggregateRoots: [],
            };
        },
        created: function () {
            // this.image = `${window.location.protocol + "//" + window.location.host}/static/image/event/bounded2.png`
        },
        watch: {
            "value.members": {
                deep: true,
                handler() {
                    this.isMembers
                }
            },
            "filteredElementValidationResults": _.debounce(function () {
                this.refresh()
            }, 200),
            // 속도 개선 로직.. 이후에 재사용 가능성있음

            // "value.preferredPlatform": {
            //     handler(newVal) {
            //         var me = this
            //         // Platform 정보 받고. Element 별로 매핑 시켜주기.
            //         me.$manifestsPerTemplate[newVal].forEach(function (element, index) {
            //             element = element.replace('./', '');
            //             me.$http.get("/static/templates/" + newVal + "/" + element)
            //                 .then(function (response) {
            //                     if ((typeof response.data) == 'string') {
            //                         var content = response.data;
            //                         if (element.includes('for-model')) {
            //                         }
            //                         var test = ''
            //                         var count = 0
            //                         var optionsCheck = content.split('---')[0];
            //                         if (!optionsCheck.includes('forEach:')) {
            //                             count = count + 1
            //                             if (element.includes('for-model')) {
            //                                 var forEach = 'Model'
            //                                 test = test.concat('forEach: ' + forEach)
            //                             } else {
            //                                 var forEach = 'BoundedContext'
            //                                 test = test.concat('forEach: ' + forEach)
            //                             }
            //                         } else {
            //                             var forEach = optionsCheck.split("forEach:")[1].split("\n")[0].trim();
            //                         }
            //
            //                         if (!optionsCheck.includes('fileName:')) {
            //                             count = count + 1
            //                             if (element.split('/')) {
            //                                 var fileName = element.substring(element.lastIndexOf("/") + 1);
            //                                 test = test.concat('\n')
            //                                 if (fileName == 'gitignore') {
            //                                     fileName = '.gitignore'
            //                                 }
            //                                 test = test.concat('fileName: ' + fileName)
            //                             }
            //                         }
            //                         if (!optionsCheck.includes('path:')) {
            //                             var pathData = element.substring(0, element.lastIndexOf("/") + 1);
            //                             count = count + 1
            //                             if (element.includes('for-model')) {
            //                                 test = test.concat('\n')
            //                                 test = test.concat(`path: ${path.dirname(element).replace('./', '')}`)
            //                             } else if (optionsCheck.includes('forEach:')) {
            //                                 test = test.concat('\n')
            //                                 test = test.concat(`path: {{boundedContext.name}}/${path.dirname(element).replace('./', '')}`)
            //                             } else {
            //                                 test = test.concat('\n')
            //                                 test = test.concat(`path: {{name}}/${path.dirname(element).replace('./', '')}`)
            //                             }
            //                         } else if (!optionsCheck.includes('forEach:')) {
            //                             var pathData = element.substring(0, element.lastIndexOf("/") + 1);
            //                             if (element.includes('for-model')) {
            //                                 test = test.concat('\n')
            //                             } else if (optionsCheck.includes(' path:')) {
            //                                 count = count + 1
            //                                 test = test.concat('\n')
            //                                 test = test.concat(`path: {{name}}/${path.dirname(element).replace('./', '')}`)
            //                             } else {
            //                                 test = test.concat('\n')
            //                             }
            //                         }
            //                         if (count == 3) {
            //                             test = test.concat('\n---\n')
            //                         } else {
            //                             test = test.concat('\n')
            //                         }
            //
            //                         if (test.length > 0) {
            //                             content = test.concat(content)
            //                         }
            //
            //                         console.log(element, response, forEach);
            //                         if(!me.value.templatePerElements) {
            //                             me.value.templatePerElements = {}
            //                         }
            //                         if(!me.value.templatePerElements[forEach]) {
            //                             me.value.templatePerElements[forEach] = [];
            //                         }
            //                         me.value.templatePerElements[forEach].push(element)
            //                     }
            //                 }).catch(error => console.log(error))
            //         });
            //     }
            // 
        },
        mounted: function () {
            var me = this
            // var webSocket = new WebSocket();
            var boundedId = this.value.elementView.id

            var $tr = $('#' + boundedId);
            $tr.parent().children().first().before($tr)

            // // Init Template
            // if (this.value.preferredPlatform == null)
            //     me.value.preferredPlatform = "spring-boot"

            // BC - innerElement
            // if (me.value.innerElement == undefined) {
            //     me.value.innerElement = []
            // }

        },
        methods: {
            openClassDiagram() {
                var me = this
                var aggregateId = ''
                var elements = me.canvasbase.value.elements
                me.aggregateRoots = []
                
                Object.values(elements).forEach((element, index) => {
                    if (element && element.elementView && !element._type.endsWith("BoundedContext")) {
                        var outer = {
                            x: me.value.elementView.x - me.value.elementView.width / 2,
                            y: me.value.elementView.y - me.value.elementView.height / 2,
                            width: me.value.elementView.width,
                            height: me.value.elementView.height
                        }
                        var inner = {
                            x: element.elementView.x - element.elementView.width / 2,
                            y: element.elementView.y - element.elementView.height / 2,
                            width: element.elementView.width,
                            height: element.elementView.height
                        }

                        if (me.canvasbase._isAttached(outer, inner)) {
                            if (element._type.endsWith('Aggregate')) {
                                me.aggregateRoots.push(element)
                                aggregateId = element.elementView.id
                            }
                        }
                    }
                })

                var umlValue = {
                    type: 'Domain Class Modeling',
                    aggId: aggregateId,
                    aggList: me.aggregateRoots
                }
                me.canvasbase.overlayText = 'Loading';
                me.canvasbase.openEmbeddedCanvas(umlValue);
            },
            close(){
                this.closePanel()
            },
            validate(panelValue, executeRelateToValidate){
                var me = this
                var executeValidate = executeRelateToValidate == false ? false :true
                var validateValue = me.propertyPanel && panelValue ? panelValue : me.value

                // Common
                // this.$super(Element).validate()

                // execute Relate Validate
                if(executeValidate) {

                }

                // Element
                if(validateValue.name){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME))
                    var isExistValidationResult = validationResultIndex == -1 ? false: true
                    if( isExistValidationResult ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }else{
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME) )
                    var isExistValidationResult = validationResultIndex == -1 ? false: true
                    if( !isExistValidationResult ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_NAME))
                    }
                }
            }
        }
    }
</script>



<style scoped lang="scss" rel="stylesheet/scss">
    .panel-title {
        font-size: 25px;
        color: #757575;
    }
</style>
